import { createStyles } from "@material-ui/core";
export var styles = function (_theme) {
    return createStyles({
        root: {
            "color": "#5278FF",
            "outline": 0,
            "textDecoration": "underline",
            "fontWeight": 700,
            "transition": "color .125s",
            "&:hover": {
                color: "#7593FF"
            }
        }
    });
};
